module.exports = __webpack_public_path__ + "img/材料力学8_11.84a76055.jpg";